import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDesktop$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDesktop extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b19de2bb1e19a36a5bdf2437c83aa4608b57948d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6f7eeaac7e50855504f756d58d1256e6d821ffc4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ce6a35bd60a2bca609370f3eaf343801457759dc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 4a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5zm14 1.5v8h-13v-8zm-11 12a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-desktop", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-desktop"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-desktop":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDesktop$1);
            }
            break;
    } });
}

const CosmosIconDesktop = CosmosIconDesktop$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDesktop, defineCustomElement };
